<script lang="ts" module>
  type TabsContentProps = {
    value: any
    class?: string | undefined | null
  }
</script>

<script lang="ts">
  import { useActions } from "#lib/internal/helpers"
  import { cn } from "#lib/utils"
  import type { Snippet } from "svelte"
  import type { HTMLAttributes } from "svelte/elements"
  import { TAB_STATES } from "."
  import { getTabsRootContext } from "./TabsRoot.svelte"

  type Props = TabsContentProps &
    HTMLAttributes<HTMLDivElement> & {
      use?: any[]
      children?: Snippet
    }

  let {
    class: className = undefined,
    value,
    use = [],
    children,
    ...restProps
  }: Props = $props()

  const rootCtx = getTabsRootContext()

  const selected = $derived($rootCtx.value === value)
</script>

{#if selected}
  <div
    class={cn(
      "focus-visible:ring-ring ring-offset-background mt-2 focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-hidden",
      className
    )}
    {...restProps}
    use:useActions={use}
    data-state={selected ? TAB_STATES.ACTIVE : TAB_STATES.INACTIVE}
    data-orientation={$rootCtx.orientation}
    role="tabpanel"
    tabindex="0"
  >
    {@render children?.()}
  </div>
{/if}
